import { FormattedMessage } from "react-intl";


export const ParkingSessionsColorLegend = () => (
    <div>
        <ul className="color-legend-items">
            <li className="color-legend-item">
                <div className="color-legend-dot session-color-paid"></div>
                <div className="color-legend-text"><FormattedMessage id="COLOR_LEGEND_SESSION_REGULAR" /></div>
            </li>

            <li className="color-legend-item">
                <div className="color-legend-dot session-color-free"></div>
                <div className="color-legend-text"><FormattedMessage id="COLOR_LEGEND_SESSION_FREE" /></div>
            </li>

            <li className="color-legend-item">
                <div className="color-legend-dot session-color-fixed"></div>
                <div className="color-legend-text"><FormattedMessage id="COLOR_LEGEND_SESSION_FIXED_DURATION" /></div>
            </li>
        </ul>
    </div>
)
